import React, { createContext } from 'react';
import { Outlet } from 'react-router-dom';
import { isEqual } from 'underscore';
import { useSelector } from 'react-redux';

import Toolbar from '../Routes/TLToolbar';
import { RootState } from '../../index';
import { useEndAddresses } from '@/hooks';
import type { EndAddressesType } from '@/hooks';

export type ViewRoutesProps = {
children: React.ReactElement;
}

export const ViewRoutesContext = createContext<EndAddressesType>({});

const ViewsRoutes: React.FC<ViewRoutesProps>  = () => {
  const  { routes } = useSelector((state: RootState) => state.routes, isEqual);
  const endAddresses = useEndAddresses(routes);

  return (
    <ViewRoutesContext.Provider value={endAddresses}>
      <Toolbar/>
      <Outlet />
    </ViewRoutesContext.Provider>
  );
};

export default ViewsRoutes;
